import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './fonts.css';
import { theme } from './theme';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// e2e-only component gallery. CRA's webpack config DefinePlugin-replaces
// `process.env.NODE_ENV` with a literal string, and webpack's own constant
// folding then eliminates an `if` branch whose test is provably false in a
// production build — BEFORE the module graph is built, so an `import()`
// inside that dead branch is never turned into a chunk at all.
// `process.env.REACT_APP_E2E`, by contrast, is NOT define-replaced by CRA (it
// stays a genuine runtime `process.env` lookup), so gating on it alone does
// NOT fold away: measured on this branch, that alone still shipped a 25.9 KB
// gallery chunk (pulling a 54.79 kB gz dayjs/@mui/x-date-pickers chunk with
// it) even though the branch could never execute in production. Anchoring the
// condition on `NODE_ENV !== 'production'` as well — and keeping the whole
// thing as a literal `if` (not a ternary/ variable indirection, which
// webpack's constant folder does not reliably see through) — gets both
// chunks dropped and brings main.js back down (287.4 -> 279.92 kB gz,
// verified via `npm run build`). e2e still works because Playwright drives
// the CRA dev server (`npm start`, NODE_ENV=development) with
// REACT_APP_E2E=true set via webServer.env in e2e/playwright.config.ts.
if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_E2E === 'true' &&
  window.location.pathname === '/kit'
) {
  const KitGallery = React.lazy(() => import('./uikit/KitGallery'));
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <React.Suspense fallback={null}>
          <KitGallery />
        </React.Suspense>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}
